import { __ } from '@wordpress/i18n';

export const FIELD_TYPES = [
    { value: 'checkbox', label: __('Checkbox', 'voxycure-framework') },
    { value: 'color', label: __('Color', 'voxycure-framework') },
    { value: 'date', label: __('Date', 'voxycure-framework') },
    { value: 'email', label: __('Email', 'voxycure-framework') },
    { value: 'gallery', label: __('Gallery', 'voxycure-framework') },
    { value: 'image', label: __('Image', 'voxycure-framework') },
    { value: 'link_button', label: __('Link Button', 'voxycure-framework') },
    { value: 'multi_select', label: __('Multi Select', 'voxycure-framework') },
    { value: 'number', label: __('Number', 'voxycure-framework') },
    { value: 'password', label: __('Password', 'voxycure-framework') },
    { value: 'radio', label: __('Radio', 'voxycure-framework') },
    { value: 'range_slider', label: __('Range Slider', 'voxycure-framework') },
    { value: 'select', label: __('Select', 'voxycure-framework') },
    { value: 'text', label: __('Text', 'voxycure-framework') },
    { value: 'textarea', label: __('Textarea', 'voxycure-framework') },
    { value: 'toggle', label: __('Toggle', 'voxycure-framework') },
    { value: 'url', label: __('URL', 'voxycure-framework') },
    { value: 'repeater', label: __('Repeater', 'voxycure-framework') },
];